import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import SellerLogin from "./pages/SellerLogin";
import ResetPassword from "./pages/ResetPassword";

import SellerMFA from "./pages/SellerMFA";
import Terms from "./pages/Terms";
import SellerDashboard from "./dashboard/SellerDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import ResetPasswordConfirm from "./pages/ResetPasswordConfirm";
import HomePage from "./dashboard/HomePage";
import { dashboardRoutes } from "./routes/dashboardRoutes";
import { renderRoutes } from "./routes/renderRoutes";

function App() {
  return (
    <Routes>
      <Route path="/login" element={<SellerLogin />} />
      <Route path="/mfa" element={<SellerMFA />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/reset-password/confirm"
        element={<ResetPasswordConfirm />}
      />

      {/* for testing in local so as not to be required to log in*/}

      {/* {
        <Route path="/dashboard/*">
          <Route element={<SellerDashboard />}>
            {renderRoutes(dashboardRoutes)}
            <Route index element={<HomePage />} />
          </Route>
        </Route>
      } */}

      {/* Protected dashboard */}
      <Route path="/dashboard/*" element={<ProtectedRoute />}>
        <Route element={<SellerDashboard />}>
          {renderRoutes(dashboardRoutes)}
          <Route index element={<HomePage />} />
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
